export const environment = {
  production: true,
  // for dev build
      //  apiUrl: 'https://yum-dev-be.digitalsaar.com/api' 
  // for test build
     apiUrl: 'https://api.tradelocal.ie/api'
}
